module.exports = __webpack_public_path__ + "static/media/relationship-path-warning.6f6c44ef.svg";